import React, { useState, useEffect } from "react";
import dashboardclasses from "../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import { ToastError } from "../../Components/utils/ToastMessage";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import swal from "sweetalert";
import {
    validateNegativeValues,
    validateEmptySpaces,
} from "../../Components/utils/validations";
function AddCategory(props) {
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const [categories, setcategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    const [base64, setbase64] = useState([]);
    const [files, setFiles] = useState([]);
    const [base64Description, setbase64Description] = useState("");
    const [filesDescription, setFilesDescription] = useState([]);
    let firstTime;
    const watchFormData = watch();
    const categorychange = (name) => {
        const body = JSON.stringify({ categoryname: name });
        Services.Get_SubCategory_Dropdown("POST", body, token)
            .then((res) => {
                if (res.Status === 1) {
                    setSubcategories(res.categories);
                    if (firstTime) {
                        let resetData = { ...props.editable };
                        delete resetData.descriptionImageURL;
                        reset({ ...resetData });
                        firstTime = false;
                    }
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const getcategories = () => {
        Services.Get_all_Categories("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setcategories(res.categories);
                    console.log(props.editable);
                    if (props.editable) {
                        firstTime = true;
                        categorychange(props.editable.categoryname);
                        console.log(props.editable.descriptionImageURL);
                        setbase64Description(
                            `${props.editable.descriptionImageURL}`
                        );
                        if (props?.editable?.serviceimagesURLs?.length > 0) {
                            let serviceimages = [];
                            for (
                                let i = 0;
                                i < props?.editable?.serviceimagesURLs?.length;
                                i++
                            ) {
                                serviceimages = [
                                    ...serviceimages,
                                    {
                                        base64: `${props?.editable?.serviceimagesURLs[i]}`,
                                        name: props?.editable
                                            ?.serviceimagesURLs[i],
                                        id: uuidv4(),
                                    },
                                ];
                            }
                            setbase64(serviceimages);
                        }
                    }
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    useEffect(() => {
        getcategories();

        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };
    const handleChange = (files) => {
        console.log(files);
        if (base64.length + files.length > 5) {
            alert("more than 5 files upload is not allowed");
            return;
        }
        for (let i = 0; i < files.length; i++) {
            if (
                files[i].type === "image/jpeg" ||
                files[i].type === "image/png"
            ) {
                let id = uuidv4();
                setFiles((prev) => [...prev, { file: files[i], id: id }]);
                let reader = new FileReader();
                reader.readAsDataURL(files[i]);
                reader.onload = function () {
                    setbase64((prev) => [
                        ...prev,
                        { base64: reader.result, id: id },
                    ]);
                };
                reader.onerror = function (error) {
                    console.log("Error: ", error);
                };
            } else {
                alert("please upload image in PNG and JPEG format ");
                break;
            }
        }
    };
    const handleChangeDescription = (file) => {
        if (file.type === "image/png" || file.type === "image/jpeg") {
            setValue("descriptionImage", file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                setbase64Description(reader.result);
            };
            reader.onerror = function (error) {
                console.log("Error: ", error);
            };
        } else {
            alert("please upload image in PNG and JPEG format ");
        }
    };
    const fileuploadDesign = (
        <div className={dashboardclasses["add-item"]}>
            <BsCloudUpload className={dashboardclasses["upload-icon"]} />
            <h5>Drag Your Image here</h5>
            <p>(Only *.jpeg and *.png images will be accepted)</p>
        </div>
    );
    const deleteHandler = (e) => {
        let id = e.currentTarget.getAttribute("id");
        let btnType = e.currentTarget.getAttribute("btnType");
        let name = e.currentTarget.getAttribute("name");
        let updatedBanners = base64.filter((item) => item.id != id);
        setbase64(updatedBanners);
        let updatedBannersfiles = files.filter((item) => item.id != id);
        setbase64(updatedBanners);
        setFiles(updatedBannersfiles);
        console.log({
            _id: props?.editable?._id,
            key: "serviceimages",
            image: name,
        });
        if (props.editable && name) {
            let body = {
                _id: props?.editable?._id,
                key: "serviceimages",
                image: name,
            };
            Services.Delete_service_image("POST", JSON.stringify(body), token)
                .then((res) => {
                    if (res.Status === 1) {
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        if (res.Message === "Token expired") {
                            Navigate("/");
                        }
                    }
                })
                .catch((err) => {
                    // alert(err);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };

    const onSubmit = (data) => {
        let AllData = data;
        delete AllData?.serviceimagesURLs;
        let formaata = new FormData();
        Object.keys(AllData).forEach((key) => {
            formaata.set(key, data[key]);
        });

        if (!props.editable) {
            if (files?.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    formaata.append("serviceimages", files[i].file);
                }
            } else {
                alert("Services images are required");
                return;
            }
            if (!data.descriptionImage) {
                alert("Description image is required");
                return;
            }

            fetch(
                `${process.env.REACT_APP_BASE_URL_NODE}/${Services.Add_Services}`,
                {
                    method: "POST",
                    body: formaata,
                    Authorization: `token ${sessionStorage.getItem("token")}`,
                }
            )
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    props.tableload(false);
                    if (res.Status === 1) {
                        Navigate(`/Services?page=1`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.getCategories();
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        } else if (props.editable) {
            formaata.delete("serviceimages");
            if (files?.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    formaata.append("serviceimages", files[i].file);
                }
            }

            console.log('props.editable :>> ', props.editable);

            formaata.set("_id", props.editable._id);

            fetch(
                `${process.env.REACT_APP_BASE_URL_NODE}/${Services.Update_Services}`,
                {
                    method: "POST",
                    body: formaata,
                    Authorization: `token ${sessionStorage.getItem("token")}`,
                }
            )
                .then((response) => response.json())
                .then((res) => {
                    console.log(res);
                    props.tableload(true);
                    if (res.Status === 1) {
                        Navigate(`/Services?page=1`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.setEditable(false);
                        props.getCategories();

                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((error) => {
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(error);
                });
        }
    };

    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable ? "Update Service" : "Add Service"}
                        </h3>
                        <p>
                            {props.editable ? "Update Service" : "Add Service"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Service Name</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("servicename", {
                                    required: "Service Name is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.servicename && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.servicename?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Category Name</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                defaultValue={""}
                                {...register("categoryname", {
                                    required: "category name is required",
                                    onChange: (e) => {
                                        categorychange(e.target.value);
                                        console.log(e.target.value);
                                    },
                                })}>
                                <option value="" disabled>
                                    Select Category
                                </option>
                                {categories.map((item) => (
                                    <option value={item.categoryname}>
                                        {item.categoryname}
                                    </option>
                                ))}
                            </select>
                            {errors?.categoryname && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.categoryname?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">subcategory Name</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                defaultValue={""}
                                {...register("subcategoryname", {
                                    required: "Subcategory name is required",
                                })}>
                                <option value="" disabled>
                                    Select Subcategory
                                </option>
                                {subcategories.map((item) => (
                                    <option value={item.subcategoryname}>
                                        {item.subcategoryname}
                                    </option>
                                ))}
                            </select>
                            {errors?.subcategoryname && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.subcategoryname?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Service Images</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={true}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <div></div>
                        <div
                            style={{
                                display: "grid",
                                gap: "0.4rem",
                                gridTemplateColumns: "1fr 1fr",
                                justifyItems: "left",
                                width: "70%",
                            }}>
                            {base64?.map((item) => (
                                <div
                                    className={
                                        dashboardclasses[
                                            "subcategory-img-wrapper"
                                        ]
                                    }>
                                    <button
                                        type="button"
                                        name={item.name}
                                        id={item.id}
                                        onClick={deleteHandler}>
                                        <AiOutlineClose />
                                    </button>
                                    <img
                                        src={item.base64}
                                        alt=""
                                        width={"120px"}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Description Image</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={handleChangeDescription}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    {base64Description.length > 0 && (
                        <div className={dashboardclasses["item-image-upload"]}>
                            <div></div>
                            <div
                                style={{
                                    display: "grid",
                                    gap: "0.4rem",
                                    gridTemplateColumns: "1fr 1fr",
                                    justifyItems: "left",
                                    width: "70%",
                                }}>
                                <div
                                    className={
                                        dashboardclasses[
                                            "subcategory-img-wrapper"
                                        ]
                                    }>
                                    <img
                                        src={base64Description}
                                        alt=""
                                        width={"120px"}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="Gender">Gender</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("servicegender", {
                                    required: "Gender is required",
                                })}>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Others">Others</option>
                            </select>
                            {errors?.servicegender && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.servicegender?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="servicebookingtimings">
                            Service Booking Timings
                        </label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("servicebookingtimings", {
                                    required:
                                        "Service Booking Timings is required",
                                })}>
                                <option value="8:00 AM to 9:00 PM">
                                    8:00 AM to 9:00 PM
                                </option>
                                <option value="9:00 AM to 6:00 PM">
                                    9:00 AM to 6:00 PM
                                </option>
                            </select>
                            {errors?.servicebookingtimings && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.servicebookingtimings?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="servicecost">Service Cost</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("servicecost", {
                                    required: "Service Cost is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.servicecost && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.servicecost?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="discount_servicecost">
                            Discount Service Cost
                        </label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("discount_servicecost", {
                                    required: "Discount is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.discount_servicecost && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.discount_servicecost?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="vendorcharges">Vendor Charges</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("vendorcharges", {
                                    required: "Vendor Charges is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.vendorcharges && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.vendorcharges?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Priority</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                {...register("priority", {
                                    required: "priority is required",
                                    validate: validateNegativeValues,
                                })}
                            />
                            {errors?.priority && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.priority?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Service Description</label>
                        <div className={dashboardclasses["select"]}>
                            <textarea
                                rows={4}
                                {...register("servicedescription", {
                                    required: "Service Description is required",
                                    validate: validateEmptySpaces,
                                })}></textarea>
                            {errors?.servicedescription && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.servicedescription?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Service Notes</label>
                        <div className={dashboardclasses["select"]}>
                            <textarea
                                rows={4}
                                {...register("servicenotes", {
                                    required: "Service notes is required",
                                    validate: validateEmptySpaces,
                                })}></textarea>
                            {errors?.servicenotes && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.servicenotes?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Customer Instructions</label>
                        <div className={dashboardclasses["select"]}>
                            <textarea
                                rows={4}
                                {...register("customerinstructions", {
                                    required:
                                        "Customer Instructions is required",
                                    validate: validateEmptySpaces,
                                })}></textarea>
                            {errors?.customerinstructions && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.customerinstructions?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Service"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
